@if (title(); as t) {
  <div class="tooltip-title">{{ t }}</div>
}
<div class="tooltip-content" #contentWrapper>
  <ng-content></ng-content>
</div>
@if (!hasCustomContent() && text(); as txt) {
  <div class="tooltip-text">{{ txt }}</div>
}
